// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from "./store";
import Axios from "axios";
import moment from "moment";
import VueCurrencyFilter from 'vue-currency-filter';

// todo
// cssVars()

Vue.prototype.$http = Axios;

const token = localStorage.getItem('token');

if (token) {
	Vue.prototype.$http.defaults.headers.common['Authorization'] = token;
}

Vue.use(BootstrapVue);

Vue.use(VueCurrencyFilter, {
	symbol: '$',
	thousandsSeparator: '.',
	fractionCount: 2,
	fractionSeparator: ',',
	symbolPosition: 'front',
	symbolSpacing: false
});

/***
 * App Filters
 */

Vue.filter('dateFormat', function (date) {
	if (date && date !== "0001-01-01T00:00:00") {
		return moment(String(date)).format('DD/MM/YYYY');
	} else {
		return '--';
	}
});

Vue.filter('dateFormatFull', function (date) {
	if (date && date !== "0001-01-01T00:00:00") {
		return moment(String(date)).format('DD/MM/YYYY hh:mm a');
	} else {
		return '--';
	}
});

Vue.filter('iconProjectPhase', function (phase) {
	let imgName = "";
	let tooltip = "";

	switch (phase) {
		case 100000000:
			imgName = "fa fa-calculator text-danger";
			tooltip = "En Valoracion";
			break;
		case 100000001:
			imgName = "fa fa-file-text-o text-info";
			tooltip = "En Oferta";
			break;
		case 100000002:
			imgName = "fa fa-list-alt";
			tooltip = "En Pedido";
			break;
		case 100000003:
			imgName = "fa fa-check-circle text-success";
			tooltip = "En CDT";
			break;
		case 100000004:
			imgName = "fa fa-headphones text-danger";
			tooltip = "En Caso";
			break;
		case 100000006:
			imgName = "fa fa-pause-circle text-info";
			tooltip = "En pausa - Seguimiento";
			break;
		case 100000007:
			imgName = "fa fa-bookmark text-warning";
			tooltip = "En Garantía";
			break;
		case 100000008:
			imgName = "fa fa-sliders text-info";
			tooltip = "Con Contrato Mantenimiento";
			break;
		case 100000009:
			imgName = "fa fa-question-circle text-secondary";
			tooltip = "Sin Procesos Asignados";
			break;
		default:
			imgName = "fa fa-stop-circle-o text-danger";
			tooltip = "Sin Proceso";
			break;
	}

	return imgName
});

Vue.filter('subStr', function (string) {
	return string.substring(0, 50) + '...';
});

Vue.filter('formatPrice', function (value) {
	if (value) {
		let val = (value / 1).toFixed(2).replace('.', ',');
		return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	} else {
		return '0,00';
	}
});

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: {
		App
	}
})
